export default __webpack_public_path__ + "static/media/acre.efa052cb.svg";